module.exports = {
  src: __webpack_public_path__ + "assets/images/transcript_image-placeholder.f84e31b0721c212c.png",
  width: 381,
  height: 457,
  toString: function() { return __webpack_public_path__ + "assets/images/transcript_image-placeholder.f84e31b0721c212c.png"; }
};